import "../css/Footer.css";
import icon_mail from "../images/icon_mail.svg";
import img_maff_logo from "../images/maff_logo.svg";
import img_logo_w from "../images/logo_w.svg";
import React, { useState, useEffect, useContext } from "react";
import { Button } from "@mui/material";
import axios from "axios";
import dayjs from "dayjs";
import { MsgContext } from "../../App";
import { API } from "./constantsFront";
import $ from "jquery";

/**
 * 一般画面フッタ
 * @returns 
 */

function FooterGen() {
  // // 更新履歴
  const [rowsNews, setRowsNews] = useState([]);

  // エラーメッセージ
  const { msg, setMsg } = useContext(MsgContext);

  // POSTデータ
  let body = { authKey: API.API_KEY };

  $("#pageTop").on("click", function () {
    $("html, body").scrollTop(0);
  });

  // 初期表示
  useEffect(() => {
    body.order = "DESC";
    axios.post("/m_news/select/", body).then(res => {
      let newsList = res.data.newsList;

      // お知らせデータ
      let rowsNews = [];
      let now = new Date();
      for (let i in newsList) {
        let news = newsList[i];
        if (rowsNews.length == 3) {
          break;
        } else if (new Date(news.publish_date) <= now) {
          let publishDate = dayjs(news.publish_date).format("YYYY/MM/DD");

          rowsNews.push(
            <dl>
              <dt>{publishDate}</dt>
              <dd style={{ wordBreak: "break-all" }}>{news.title}</dd>
            </dl>
          );
        }
      }
      setRowsNews(rowsNews);
    }).catch((err) => {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    });
  }, [])

  return (
    <>
      {/* <footer className="footer01">
        <ul className="menu">
          <li><p>海外の食品規則チェックサイト</p></li>
          <li><a href={"./"}>検索TOP</a>&nbsp;/&nbsp;</li>
          <li><a href={"./D006FirstTime"}>初めての方へ</a>&nbsp;/&nbsp;</li>
          <li><a href={"./D00501QuestionList"}>よくあるご質問</a>&nbsp;/&nbsp;</li>
          <li><a href={"./D007RoadMap"}>輸出要件・規制一覧</a>&nbsp;/&nbsp;</li>
          <li><a href={"./D008UpdateLog"}>更新履歴</a>&nbsp;/&nbsp;</li>
          <li><a href={"./D010TermsService"}>利用規約・免責事項</a>&nbsp;/&nbsp;</li>
          <li><a href={"./D011PrivacyPolicy"}>プライバシーポリシー</a></li>
          <li>
            <Button className="footer_button" href="./D0041ContactTop">お問い合わせ</Button>
          </li>
        </ul>
        <p className="copyright">
          Copyright (c) XXXXXX. All Rights Reserved
        </p>
      </footer> */}
      <footer id="footer">
        <div id="pageTop"></div>
        <div class="footerHistory">
          <div class="footerHistoryInner">
            <div class="titleWrap">
              <p class="title" style={{ whiteSpace: "nowrap" }}>更新履歴</p>
              <a href="./D008UpdateLog" class="ichiran">一覧へ</a>
            </div>
            <div class="historyList">
              {rowsNews}
            </div>
          </div>
        </div>
        <div class="footerWrap">
          <div class="footerInner">
            <div class="footerLeft">
              <div class="footerLogo"><img src={img_logo_w} alt="MARS" /></div>
              <ul class="footerNav">
                <li><a href="./">トップ</a></li>
                <li><a href="./D006FirstTime">初めての方へ</a></li>
                <li><a href="./D007RoadMap">輸出要件・規制一覧</a></li>
                <li><a href="./D00501QuestionList">よくあるご質問</a></li>
                <li><a href="./D008UpdateLog">更新履歴</a></li>
              </ul>
            </div>
            <div class="footerRight">
              <div class="footerContact">
                <a href="./D0041ContactTop">
                  <span class="icon">
                    <img src={icon_mail} alt="" />
                  </span>お問合せ</a>
              </div>
              <div class="footerBottom">
                <div class="footerSubNavWrap">

                  <ul class="footerSubNav">
                    <li><a href="./D010TermsService">利用規約・免責事項</a></li>
                    <li><a href="./D011PrivacyPolicy">プライバシーポリシー</a></li>
                    <li><a href="./D0141OperatingOrganization">運営組織</a></li>
                  </ul>
                  <p class="copyright">Copyright : Ministry of Agriculture, Forestry and Fisheries</p>
                </div>
                <div class="maff_logo"><img src={img_maff_logo} alt="MAFF" /></div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default FooterGen;
